module.exports = __webpack_public_path__ + "static/img/left_UP.6e82e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left_UP.png?1
// module id = AQYW
// module chunks = 1